"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Hourglass12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 2.5L9.76822 2.5C9.50735 3.73983 8.95287 5.23698 7.77429 6C8.95287 6.76303 9.50735 8.26017 9.76822 9.50001L9.7841 9.57693H10.5V11.5769H1.5V9.57693H2.2159C2.22106 9.5514 2.22636 9.52576 2.23178 9.5C2.49265 8.26017 3.04713 6.76303 4.22571 6C3.04713 5.23697 2.49265 3.73983 2.23178 2.5H1.5V0.5H2H4.00008H7.99992H10H10.5V2.5ZM4.39737 2.86754C4.35679 2.74582 4.32018 2.62282 4.28717 2.5L7.71283 2.5C7.67982 2.62282 7.64321 2.74582 7.60263 2.86754C7.18973 4.10625 6.67149 4.5 6 4.5C5.32851 4.5 4.81027 4.10625 4.39737 2.86754ZM7.71283 9.50001C7.67982 9.37719 7.64321 9.25418 7.60263 9.13246C7.18973 7.89375 6.67149 7.5 6 7.5C5.32851 7.5 4.81027 7.89375 4.39737 9.13246C4.35679 9.25418 4.32018 9.37719 4.28717 9.50001H7.71283Z", fill: "#131416" }));
}
function Hourglass12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Hourglass12Svg, Object.assign({}, svgProps)));
}
exports.default = Hourglass12;
//# sourceMappingURL=Hourglass12.js.map